import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "ct_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export async function login(email, password) {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.access_token);
  return data.user;
}

export async function fetchMe() {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeaders() });
  return data;
}

export async function fetchSubmissions() {
  const { data } = await axios.get(`${API}/partners`, { headers: authHeaders() });
  return data;
}

export async function downloadCsv() {
  const res = await axios.get(`${API}/partners/export`, {
    headers: authHeaders(),
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `partner-applications-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export { API };

export async function deleteSubmission(id) {
  await axios.delete(`${API}/partners/${id}`, { headers: authHeaders() });
}
